import React from 'react'

export const H4 = (props) => (
  <h4 className="ma0 fw6">{props.children}</h4>
)



// WEBPACK FOOTER //
// ./src/components/Text.js